import React, { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { NonAdminPreviewBanner } from '../../components/NonAdminPreviewBanner';
import { useAuthContext } from '../../context/AuthContext';
import { useNotificationContext } from '../../context/NotificationContext';
import { ApiService } from '../../services/api';
import { CameraImageResponse } from '../../types';
import { CandidateDetail } from './components/CandidateDetail';
import { PageLoadingSpinner } from './components/PageLoadingSpinner';

export const CandidateDetailPage: React.FC = () => {
  const { imageId } = useParams<{ imageId: string }>();
  const { token } = useAuthContext();
  const { showErrorToast } = useNotificationContext();
  const [cameraImage, setCameraImage] = useState<CameraImageResponse | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  const fetchCameraImage = useCallback(async () => {
    if (!imageId) return;

    setIsLoading(true);
    try {
      const data = await ApiService.fetchCameraImage(token, imageId, {
        countActiveEmbeddings: true,
      });
      setCameraImage(data);
    } catch (err) {
      showErrorToast('Failed to fetch camera image');
    } finally {
      setIsLoading(false);
    }
  }, [imageId, token, showErrorToast]);

  useEffect(() => {
    fetchCameraImage();
  }, [fetchCameraImage]);

  if (!imageId) return null;

  if (isLoading) {
    return <PageLoadingSpinner message="Loading camera image..." fullScreen />;
  }

  if (!cameraImage) return null;

  return (
    <div className="min-h-screen bg-gray-50 px-6 py-4">
      <NonAdminPreviewBanner />
      <CandidateDetail key={imageId} cameraImage={cameraImage} />
    </div>
  );
};

export default CandidateDetailPage;
